import type { WebModule } from "../../core/modules";
import { TenantsList } from "./routes/list";
import { TenantSettings } from "./routes/settings";
import { TenantSwitcher } from "./components/tenant-switcher";
import { MyTenantCard } from "./components/my-tenant-link";

// Établissements + portail scopé : sélecteur en barre du haut, liste admin,
// page de configuration accessible aux responsables.
const tenants: WebModule = {
  name: "tenants",
  routes: [
    { path: "/etablissements", element: <TenantsList />, adminOnly: true },
    { path: "/etablissements/:tenantId", element: <TenantSettings /> },
  ],
  nav: [
    {
      title: "Établissements",
      adminOnly: true,
      items: [{ to: "/etablissements", label: "Établissements", icon: "building", end: true }],
    },
  ],
  homeWidgets: [{ id: "tenants-current", element: <MyTenantCard /> }],
  topbar: <TenantSwitcher />,
};

export default tenants;
